import { render, staticRenderFns } from "./AmbulanciasTrasladosLocales.vue?vue&type=template&id=3003e316"
import script from "./AmbulanciasTrasladosLocales.vue?vue&type=script&lang=js"
export * from "./AmbulanciasTrasladosLocales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports